import { JsonObject, JsonProperty } from 'json2typescript';

import { QuestionGroupInterface } from '../../../core';
import { QuestionOption } from './question-option';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('QuestionGroup')
export class QuestionGroup implements QuestionGroupInterface {
    @JsonProperty('Description', StringAdapter, true)
    private _description: string = undefined;

    @JsonProperty('Options', [QuestionOption], true)
    private _options: QuestionOption[] = undefined;

    get description(): string {
        return this._description;
    }

    set description(value: string) {
        this._description = value;
    }

    get options(): QuestionOption[] {
        if (!this._options) {
            this._options = [];
        }

        return this._options.sort((a: QuestionOption, b: QuestionOption) => {
            if (a.order < b.order) {
                return -1;
            } else if (a.order > b.order) {
                return 1;
            }

            return 0;
        });
    }
}
